<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" type="ball-grid-pulse"></ngx-spinner>